/**
 * Environment configuration
 * Centralized access to environment variables
 */

// No longer logging environment config to reduce noise

const enhancedUiMultibankFlag = import.meta.env.VITE_ENHANCED_UI_MULTIBANK_ENABLED;

export const env = {
  // Mode and brand
  mode: import.meta.env.MODE,
  brand: import.meta.env.VITE_BRAND || 'standard',
  enhancedUiMultibankEnabled: enhancedUiMultibankFlag == null || enhancedUiMultibankFlag !== 'false',
  
  // Light mode colors
  light: {
    buttonBorder: import.meta.env.VITE_LIGHT_BUTTON_BORDER,
    buttonText: import.meta.env.VITE_LIGHT_BUTTON_TEXT,
    buttonGradientStart: import.meta.env.VITE_LIGHT_BUTTON_GRADIENT_START,
    buttonGradientEnd: import.meta.env.VITE_LIGHT_BUTTON_GRADIENT_END,
    bankDetailsText: import.meta.env.VITE_LIGHT_BANK_DETAILS_TEXT,
    confirmationSubmitBg: import.meta.env.VITE_LIGHT_CONFIRMATION_SUBMIT_BG,
    confirmationSubmitBorder: import.meta.env.VITE_LIGHT_CONFIRMATION_SUBMIT_BORDER,
    confirmationCancelBg: import.meta.env.VITE_LIGHT_CONFIRMATION_CANCEL_BG,
    confirmationCancelBorder: import.meta.env.VITE_LIGHT_CONFIRMATION_CANCEL_BORDER,
    offlinePrimaryBg: import.meta.env.VITE_LIGHT_OFFLINE_PRIMARY_BG,
    offlineSecondaryBorder: import.meta.env.VITE_LIGHT_OFFLINE_SECONDARY_BORDER,
    offlineSecondaryText: import.meta.env.VITE_LIGHT_OFFLINE_SECONDARY_TEXT,
  },
  
  // Dark mode colors
  dark: {
    buttonBorder: import.meta.env.VITE_DARK_BUTTON_BORDER,
    buttonText: import.meta.env.VITE_DARK_BUTTON_TEXT,
    buttonGradientStart: import.meta.env.VITE_DARK_BUTTON_GRADIENT_START,
    buttonGradientEnd: import.meta.env.VITE_DARK_BUTTON_GRADIENT_END,
    bankDetailsText: import.meta.env.VITE_DARK_BANK_DETAILS_TEXT,
    confirmationSubmitBg: import.meta.env.VITE_DARK_CONFIRMATION_SUBMIT_BG,
    confirmationSubmitBorder: import.meta.env.VITE_DARK_CONFIRMATION_SUBMIT_BORDER,
    confirmationCancelBg: import.meta.env.VITE_DARK_CONFIRMATION_CANCEL_BG,
    confirmationCancelBorder: import.meta.env.VITE_DARK_CONFIRMATION_CANCEL_BORDER,
    offlinePrimaryBg: import.meta.env.VITE_DARK_OFFLINE_PRIMARY_BG,
    offlineSecondaryBorder: import.meta.env.VITE_DARK_OFFLINE_SECONDARY_BORDER,
    offlineSecondaryText: import.meta.env.VITE_DARK_OFFLINE_SECONDARY_TEXT,
    primary: import.meta.env.VITE_DARK_PRIMARY,
    primaryDark: import.meta.env.VITE_DARK_PRIMARY_DARK,
    primaryLight: import.meta.env.VITE_DARK_PRIMARY_LIGHT,
    
    gradientStart: import.meta.env.VITE_DARK_GRADIENT_START,
    gradientEnd: import.meta.env.VITE_DARK_GRADIENT_END,
    
    secondary: import.meta.env.VITE_DARK_SECONDARY,
    secondaryLight: import.meta.env.VITE_DARK_SECONDARY_LIGHT,
    secondaryDark: import.meta.env.VITE_DARK_SECONDARY_DARK,
    
    success: import.meta.env.VITE_DARK_SUCCESS,
    successLight: import.meta.env.VITE_DARK_SUCCESS_LIGHT,
    successDark: import.meta.env.VITE_DARK_SUCCESS_DARK,
    
    error: import.meta.env.VITE_DARK_ERROR,
    errorLight: import.meta.env.VITE_DARK_ERROR_LIGHT,
    errorDark: import.meta.env.VITE_DARK_ERROR_DARK,
    
    warning: import.meta.env.VITE_DARK_WARNING,
    warningLight: import.meta.env.VITE_DARK_WARNING_LIGHT,
    warningDark: import.meta.env.VITE_DARK_WARNING_DARK,
    warningRed: import.meta.env.VITE_DARK_WARNING_RED,
    
    info: import.meta.env.VITE_DARK_INFO,
    infoLight: import.meta.env.VITE_DARK_INFO_LIGHT,
    infoBlue: import.meta.env.VITE_DARK_INFO_BLUE,
    infoDark: import.meta.env.VITE_DARK_INFO_DARK,
    
    dark: import.meta.env.VITE_DARK_DARK,
    grayDarkerFont: import.meta.env.VITE_DARK_GRAY_DARKER_FONT,
    grayDark: import.meta.env.VITE_DARK_GRAY_DARK,
    gray: import.meta.env.VITE_DARK_GRAY,
    grayLight: import.meta.env.VITE_DARK_GRAY_LIGHT,
    grayLimitFont: import.meta.env.VITE_DARK_GRAY_LIMIT_FONT,
    grayLighter: import.meta.env.VITE_DARK_GRAY_LIGHTER,
    light: import.meta.env.VITE_DARK_LIGHT,
    white: import.meta.env.VITE_DARK_WHITE,
    
    textPrimary: import.meta.env.VITE_DARK_TEXT_PRIMARY,
    textSecondary: import.meta.env.VITE_DARK_TEXT_SECONDARY,
    textLight: import.meta.env.VITE_DARK_TEXT_LIGHT,
    textMuted: import.meta.env.VITE_DARK_TEXT_MUTED,
    textError: import.meta.env.VITE_DARK_TEXT_ERROR,
    textLabel: import.meta.env.VITE_DARK_TEXT_LABEL,
    textInputColor: import.meta.env.VITE_DARK_TEXT_INPUT_COLOR,
    
    bgPrimary: import.meta.env.VITE_DARK_BG_PRIMARY,
    bgSecondary: import.meta.env.VITE_DARK_BG_SECONDARY,
    bgDark: import.meta.env.VITE_DARK_BG_DARK,
    bgLight: import.meta.env.VITE_DARK_BG_LIGHT,
    accordionBg: import.meta.env.VITE_DARK_ACCORDION_BG,

    checkedColor: import.meta.env.VITE_DARK_CHECKED_COLOR,
    checkedTickColor: import.meta.env.VITE_DARK_CHECKED_TICK_COLOR
  }
};
